export default __webpack_public_path__ + "static/media/habano-2Open.dabb8f7e.jpg";